var exports = {
  "RC": "x4ddf2309--ff280a--preloader",
  "HU": "x4ddf2309--ff280a--preload-overlay",
  "kL": "x4ddf2309--ff280a--container",
  "Ox": "x4ddf2309--ff280a--village-list",
  "nk": "x4ddf2309--ff280a--header-fixed",
  "Pm": "x4ddf2309--ff280a--adaptive-header",
  "R_": "x4ddf2309--ff280a--heading",
  "z": "x4ddf2309--ff280a--summary",
  "jD": "x4ddf2309--ff280a--breadcrumbs",
  "xA": "x4ddf2309--ff280a--breadcrumbs-divider",
};

module.exports = exports;
